import {
  SchoolOutline,
  NotebookMultiple,
  AccountSupervisor,
  FrequentlyAskedQuestions,
  CompassOutline,
  ChartTimeline,
  AccountCogOutline,
  AccountAlertOutline,
  MagnifyPlusOutline,
  Cpu64Bit
} from 'mdi-material-ui'
import { Vip } from 'src/components/icons/vip'
import { FeatureCodes, moduleKeys } from 'src/components/common/featureData'
import { ExamAttendance } from 'src/components/icons/examAttendance'

export const operationMenu = {
  [FeatureCodes.OMS.classManagement]: {
    title: 'Class Management',
    icon: AccountCogOutline,
    path: `/class-management`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.attendanceManagement]: {
    title: 'Attendance Management',
    icon: AccountSupervisor,
    path: `/attendance-management`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.AdmittedStudentList]: {
    title: 'Admitted Student',
    icon: SchoolOutline,
    path: `/admitted-students-list`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.progressReportAndTranscripts]: {
    title: 'Progress Report & Transcripts',
    icon: SchoolOutline,
    path: `/progress-report-and-transcripts`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.queryDashboard]: {
    title: 'Query Dashboard',
    icon: FrequentlyAskedQuestions,
    path: `/query-dashboard`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.viewAndDownloadGraduation]: {
    title: 'View & Download Graduation List',
    icon: NotebookMultiple,
    path: `/view-and-download-graduation-list`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.VIPStudents]: {
    title: 'VIP Students',
    icon: Vip,
    path: `/vip-students`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.orientationSchedule]: {
    title: 'Orientation Schedule',
    icon: CompassOutline,
    path: `/orientation-schedule`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.throughputReport]: {
    title: 'Throughput Report',
    icon: ChartTimeline,
    path: `/throughput-report`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.riskDashboard]: {
    title: 'Risk Dashboard',
    icon: AccountAlertOutline,
    path: `/risk-dashboard`,
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.UnenrolledStudent]: {
    title: 'Unenrolled Student',
    icon: SchoolOutline,
    path: `/unenrolledStudent`,
    badgeColor: 'error',
    module: moduleKeys.operation
  },
  [FeatureCodes.HOD.electiveModuleMonitoring]: {
    title: 'Elective Module Monitoring',
    icon: MagnifyPlusOutline,
    path: `/hod/elective-module-monitoring`,
    module: moduleKeys.operation
  },
  [FeatureCodes.OMS.examProctoring]: {
    title: 'Exam Proctoring',
    icon: ExamAttendance,
    path: `/exam-proctoring`,
    module: moduleKeys.operation,
    requiredRole: 'Exam_Proctoring'
  },
  [FeatureCodes.OMS.aiRiskProfile]: {
    title: 'Beta - AI Student Risk Monitoring',
    icon: Cpu64Bit,
    path: `/ai-risk-profile`,
    module: moduleKeys.operation,
    requiredRole: 'AI_Risk_Profile'
  }
}
